// Forzar build limpio en Cloudflare Pages
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Pacientes from './pages/Pacientes';
import PacientesEliminados from './pages/PacientesEliminados';
import AgregarPaciente from './pages/AgregarPaciente';
import DetallesPaciente from './pages/DetallesPaciente';
import PlanesAlimentarios from './pages/PlanesAlimentarios';
import Email from './pages/Email';
import Agenda from './pages/Agenda';
import Login from './pages/Login';
import axios from 'axios';
import { axiosConfig } from './config';
import { ComposeModalsProvider } from './contexts/ComposeModalsContext';
import Facturacion from './pages/Facturacion';
import FacturacionConfig from './pages/FacturacionConfig';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#035fa4',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

// Configurar Axios globalmente
axios.defaults.baseURL = axiosConfig.baseURL;
axios.defaults.timeout = axiosConfig.timeout;
axios.defaults.headers.common['Content-Type'] = axiosConfig.headers['Content-Type'];

// Configurar interceptor de Axios
axios.interceptors.request.use(
  config => {
    // Agregar token si existe
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    // console.log('Response:', response);
    return response;
  },
  error => {
    console.error('Response Error:', error);
    if (error.code === 'ECONNABORTED') {
      console.error('La conexión al servidor ha excedido el tiempo de espera');
    }
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

function ProtectedRoute({ children }: { children: JSX.Element }) {
  const location = useLocation();
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

// Componente para manejar la ruta base
function BaseRoute() {
  const token = localStorage.getItem('token');
  
  if (token) {
    // Si hay token, redirigir al dashboard
    return <Navigate to="/dashboard" replace />;
  } else {
    // Si no hay token, mostrar login
    return <Login />;
  }
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ComposeModalsProvider>
        <Routes>
          {/* Ruta base - maneja autenticación sin layout */}
          <Route path="/" element={<BaseRoute />} />
          
          {/* Ruta de login */}
          <Route path="/login" element={<Login />} />
          
          {/* Rutas protegidas con layout */}
          <Route
            path="/*"
            element={
              <Layout>
                <Routes>
                  <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                  <Route path="/pacientes" element={<ProtectedRoute><Pacientes /></ProtectedRoute>} />
                  <Route path="/pacientes-eliminados" element={<ProtectedRoute><PacientesEliminados /></ProtectedRoute>} />
                  <Route path="/pacientes/agregar" element={<ProtectedRoute><AgregarPaciente /></ProtectedRoute>} />
                  <Route path="/pacientes/:id" element={<ProtectedRoute><DetallesPaciente /></ProtectedRoute>} />
                  <Route path="/planes" element={<ProtectedRoute><PlanesAlimentarios /></ProtectedRoute>} />
                  <Route path="/email" element={<ProtectedRoute><Email /></ProtectedRoute>} />
                  <Route path="/agenda" element={<ProtectedRoute><Agenda /></ProtectedRoute>} />
                  {/* <Route path="/facturacion" element={<ProtectedRoute><Facturacion /></ProtectedRoute>} /> */}
                  <Route path="/facturacion-config" element={<ProtectedRoute><FacturacionConfig /></ProtectedRoute>} />
                  {/* Redirigir cualquier ruta no encontrada al dashboard */}
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </ComposeModalsProvider>
    </ThemeProvider>
  );
}

export default App; 